import React, { Fragment } from 'react';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import ProjectIssueList from 'components/Agile/projectIssue/projectIssueList';
import ProjectIssueDetail from 'components/Agile/projectIssue/projectIssueDetail';
import ProjectIssueAdd from 'components/Agile/projectIssue/projectIssueAdd';
import JiraProjectIssueAdd from 'components/Agile/projectIssue/jiraProjectIssueAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';

export class Component extends React.Component {
    addFavouriteProjectIssue = (data) => {
        this.props.addFavouriteProjectIssue(data);
    };
    onProjectIssueSelect = (data) => {
        this.props.onProjectIssueSelect(data);
    };
    onAddProjectIssue = () => {
        this.props.onAddProjectIssue(); // true - add non-jira issue, false - jira issue
    };
    onAddJiraProjectIssue = () => {
        this.props.onAddJiraProjectIssue(); // true - add non-jira issue, false - jira issue
    };
    onProjectIssueClose = () => {
        this.props.onProjectIssueClose();
    };
    onJiraProjectIssueClose = () => {
        this.props.onJiraProjectIssueClose();
    };
    onFilterProjectIssueOptionSelect = (option) => {
        this.props.onFilterProjectIssueOptionSelect(option);
    };
    onSaveProjectIssue = (data) => {
        this.props.onSaveProjectIssue(data);
    };
    onSaveJiraProjectIssue = (data) => {
        this.props.onSaveJiraProjectIssue(data);
    };
    onDeleteProjectIssue = (data) => {
        this.props.onDeleteProjectIssue(data);
    };
    onFilterSelectedProjectIssue = () => {
        this.props.onFilterSelectedProjectIssue();
    };
    filterProjectIssue = (projectIssueName) => {
        if (projectIssueName === '') {
            this.onFilterProjectIssueOptionSelect(this.props.filterOption);
        } else {
            this.props.filterProjectIssue(projectIssueName);
        }
    };
    handleProjectIssueRequestClose = () => {
        this.props.handleProjectIssueRequestClose();
    };
    getAllProjectIssue = () => {
        this.props.getAllProjectIssue();
    };
    getUnselectedAllProjectIssue = () => {
        this.props.getUnselectedAllProjectIssue();
    };
    onAllProjectIssueSelect = () => {
        const selectAll = this.props.selectedProjectIssues < this.props.projectIssueList.length;
        if (selectAll) {
            this.props.getAllProjectIssue();
        } else {
            this.props.getUnselectedAllProjectIssue();
        }
    };
    onToggleProjectIssueDrawer = () => {
        this.props.onToggleProjectIssueDrawer();
    };
    showProjectIssueLoader = () => {
        this.props.showProjectIssueLoader();
    }

    constructor() {
        super();
    }
    componentDidMount() {
        this.props.showProjectIssueLoader();
        this.props.fetchProjectIssues(true); // use the cache
    }
    updateSearchProjectIssue(evt) {
        this.props.updateSearchProjectIssue(evt.target.value);
        this.props.filterProjectIssue(evt.target.value);
    }
    setProjectIssue = (id) => {
        this.props.setProjectIssue(id);
    }
    projectIssueSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.projectIssues" /></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    {/* REFER TO ISSUES - NON JIRA ISSUES - NOT ADDING HERE - ONLY SHOWING COMPANY JIRA PROJECT ISSUES <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={this.onAddProjectIssue}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="sidebar.addNewProjectIssue" /></span>
                        </Button>
                    </div> */}
                    {/* <div className="module-add-task"  style={{ marginTop: '-40px' }}>
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={this.onAddJiraProjectIssue}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="sidebar.addNewJiraProjectIssue" /></span>
                        </Button>
                    </div> */}
                </CustomScrollbars>
            </div>
        </div>;
    };

    render() {
        const {
            selectedProject,
            width,
            selectedProjectIssue,
            projectIssue,
            projectIssueList,
            addProjectIssueState,
            addJiraProjectIssueState,
            alertMessage,
            showMessage,
            drawerState,
            noContentFoundMessage,
            loader
        } = this.props;
        return (
            <div className="app-wrapper">
                <div className="app-module animated slideInUpTiny animation-duration-3">
                    <div className="d-block d-xl-none">
                        <Drawer
                            touch={true}
                            transitions={true}
                            enableDragHandle={true}
                            open={drawerState}
                            onOpenChange={this.onToggleProjectIssueDrawer.bind(this)}
                            sidebar={this.projectIssueSideBar(projectIssue)} />
                    </div>
                    <div className="app-module-sidenav d-none d-xl-flex">
                        {this.projectIssueSideBar(projectIssue)}
                    </div>
                    <div className="module-box">
                        <div className="module-box-content">
                            <div className="module-box-header">
                                <span className="icon-btn drawer-btn d-flex d-xl-none"
                                    onClick={this.onToggleProjectIssueDrawer.bind(this)}>
                                    <i className="zmdi zmdi-menu" />
                                </span>
                                <div className="d-flex align-items-center justify-content-center" style={{ padding: 10 }}>
                                    Project issues for selected project - {selectedProject?.name}. NOTE - This dashboard uses data that may be cached for up to 1 hour&nbsp;&nbsp;&nbsp;
                                    <Button className="jr-btn jr-btn-sm btn-primary text-white mb-0" color="primary"
                                        onClick={() => {
                                            this.props.showProjectIssueLoader();
                                            this.props.fetchProjectIssues(false); // DONT use the cache
                                        }}
                                    >
                                        Refresh Now
                                    </Button>
                                </div>
                            </div>
                            <div className="module-box-topbar">
                            </div>
                            <CustomScrollbars className="module-list-scroll scrollbar"
                                style={{ height: this.props.width >= 1200 ? 'calc(105vh - 265px)' : 'calc(105vh - 245px)' }}>
                                {loader ?
                                    <div
                                        className="loader-view-block h-100">
                                        <div className="loader-view">
                                            <CircularProgress />
                                        </div>
                                    </div>
                                    :
                                    projectIssueList && projectIssueList.length > 0 ?
                                        <Fragment>
                                            <ProjectIssueList
                                                data={projectIssueList}
                                                width={width}
                                                setProjectIssue={this.setProjectIssue.bind(this)}
                                                onDeleteProjectIssue={this.onDeleteProjectIssue.bind(this)}
                                                onSaveProjectIssue={this.onSaveProjectIssue.bind(this)}
                                                showProjectIssueLoader={this.showProjectIssueLoader.bind(this)}
                                            />
                                            <div style={{ marginTop: 10 }}>
                                                <ProjectIssueDetail
                                                    projectIssueList={projectIssueList}
                                                    selectedProjectIssue={selectedProjectIssue}
                                                    width={width}
                                                    setProjectIssue={this.setProjectIssue.bind(this)}
                                                    onDeleteProjectIssue={this.onDeleteProjectIssue.bind(this)}
                                                    onSaveProjectIssue={this.onSaveProjectIssue.bind(this)}
                                                    showProjectIssueLoader={this.showProjectIssueLoader.bind(this)}
                                                />
                                            </div>
                                        </Fragment>
                                        :
                                        <div className="h-100 d-flex align-items-center justify-content-center">
                                            {noContentFoundMessage}
                                        </div>
                                }
                            </CustomScrollbars>
                        </div>
                    </div>
                </div>
                <ProjectIssueAdd
                    open={addProjectIssueState}
                    projectIssue={{
                        'id': '',
                        'orgid': '',
                        'name': '',
                        'email': '',
                        'phone': '',
                        'designation': '',
                        'thumb': null,
                        'selected': false,
                        'starred': false,
                        'frequently': false,
                    }}
                    onSaveProjectIssue={this.onSaveProjectIssue}
                    onProjectIssueClose={this.onProjectIssueClose}
                    onDeleteProjectIssue={this.onDeleteProjectIssue}
                    showProjectIssueLoader={this.showProjectIssueLoader}
                />
                <JiraProjectIssueAdd
                    open={addJiraProjectIssueState}
                    projectIssue={{
                        'id': '',
                        'orgid': '',
                        'name': '',
                        'email': '',
                        'phone': '',
                        'designation': '',
                        'thumb': null,
                        'selected': false,
                        'starred': false,
                        'frequently': false,
                    }}
                    onSaveJiraProjectIssue={this.onSaveJiraProjectIssue}
                    onJiraProjectIssueClose={this.onJiraProjectIssueClose}
                    showProjectIssueLoader={this.showProjectIssueLoader}
                />

                {showMessage && NotificationManager.success(alertMessage, this.handleProjectIssueRequestClose())}
                <NotificationContainer />

            </div>
        );
    }
}

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/projectIssue/component.js